import React, { useMemo } from 'react';
import block from 'bem-cn';
import SVG from 'components/SVG';

import { actions as notificationsActions } from 'features/notifications/index';
import { useDispatch, useSelector } from 'react-redux';

import bellSVG from 'shared/img/bell.svg';
import './NotificationsButton.scss';

const b = block('notifications-button');

const NotificationsButton = ({ inBurger }) => {
  const dispatch = useDispatch();
  const { notifications } = useSelector(state => state.notifications);

  const hasNotifys = useMemo(() => {
    return notifications.some(n => n.new === true);
  }, [notifications]);

  const handleClick = () => {
    dispatch(notificationsActions.changeVisibilityOfNotifications());
  };

  return (
    <div className={b({ inBurger: inBurger })} onClick={handleClick}>
      <SVG className={b('icon')} svgProps={{ svg: bellSVG }}></SVG>
      {hasNotifys && <div className={b('hasNotifys')} />}
    </div>
  );
};

export default NotificationsButton;
